import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbInputNumber as ClbInputNumber_ } from '@celebration/design-system/dist/lib/input-number';
const events = {
    onClbChange: ClbInputNumber_.events
        .onClbChange,
};
export const ClbInputNumber = createComponent({
    tagName: ClbInputNumber_.tagName,
    elementClass: ClbInputNumber_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map